<template>
    <v-dialog class="content-dialog" v-model="customerDialog" persistent :fullscreen="mobile">
        <div v-if="!customer && loading" class="dialog-loading-container">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <v-card rounded="lg">
            <CustomerDialogHeader :customers="customer" v-if="customer" @close="closeDialog" />
            <v-divider></v-divider>
            <div class="content-dialog-card">
                <v-row>
                    <v-col cols="12" sm="6">
                        <div class="content-dialog-data-wrapper">
                            <CustomerDialogRawData :customers="customer" v-if="customer" />
                            <v-divider></v-divider>
                            <CustomerDialogData :customers="customer" v-if="customer" />
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <div class="customer-dialog-tables-wrapper">
                            <CustomerDialogTablesData :customers="customer" v-if="customer" />
                            <CustomerDialogCustomerLogins :customers="customer" v-if="customer" />
                        </div>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { useDisplay } from 'vuetify'
import CustomerDialogHeader from './CustomerDialogHeader.vue';
import CustomerDialogTablesData from './CustomerDialogTablesData.vue';
import CustomerDialogData from './CustomerDialogData.vue';
import CustomerDialogRawData from './CustomerDialogRawData.vue';
import CustomerDialogCustomerLogins from './CustomerDialogCustomerLogins.vue';
import { mapState, mapActions } from 'vuex';

export default {
    components: {
        CustomerDialogHeader,
        CustomerDialogTablesData,
        CustomerDialogData,
        CustomerDialogRawData,
        CustomerDialogCustomerLogins
    },
    props: {
        customerId: {
            type: String,
            required: true
        }
    },
    setup() {
        const { mobile } = useDisplay();
        return { mobile };
    },
    data() {
        return {

        }
    },
    watch: {
        customerId: {
            handler(newId, oldId) {
                if (newId && newId !== oldId) {
                    this.fetchCustomerData(newId);
                }
            },
            immediate: true
        }
    },
    computed: {
        ...mapState('customer', ['loading', 'customer', 'customerDialog'])
    },
    methods: {
        ...mapActions('customer', ['fetchCustomerData', 'closeCustomerDialog', 'setCustomerDialog', 'resetCustomerData']),
        closeDialog() {
            this.$store.dispatch('customer/closeCustomerDialog');
        },
    },
    beforeUnmount() {
        this.resetCustomerData();
    }

}
</script>

<style lang="scss" scoped></style>